import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchUserBOCIdByADB2CIdStandaloneProcess } from "../../actions/Web/Customer/SignUp";
import Loader from "../../components/shared/loader/Loader";
import ErrorPage from "../../components/shared/errorPage/ErrorPage";
import { useTranslation } from "react-i18next";
import { useIssueBOLToken } from "../../utils/CustomHooks/useIssueBOLToken";
import { buildSkipRegistrationQSNativeApp, updateNativeAppQueryParams_LocalStorage } from "../../constants/AppMethod";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { nativeAppRoutePaths } from "../../constants/Routes";
import { getLocalSessionData } from "../../utils/Authentication/handleUserSession";
import { LOCALSESSIONDATAKEYS, NATIVE_APP_AUTHENTICATION_FLAG } from "../../constants/AppConstants";

const AuthOnlyHandler = () => {
    const { t } = useTranslation(["translation"]);
    const dispatch = useDispatch();
    const history = useHistory();
    const authTokenInfo = JSON.parse(getLocalSessionData(LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO));
    const isAuthTokenInfoExists = authTokenInfo?.includes('token');

    const {
        data: BOCUserInfoData,
        error: BOCUserInfoErr,
        success: BOCUserInfosuccess
    } = useSelector(state => state.GetUserBOCIdByADB2CId);

    const { 
        fetchToken, 
        BOLApiToken_error,
        BOLApiToken_success,
        BOLApiToken_data
    } = useIssueBOLToken(true); // set 'isOnlyAuth' status true


    const handleAppRedirection = () => {
        const QS = buildSkipRegistrationQSNativeApp(NATIVE_APP_AUTHENTICATION_FLAG.HAS_COMPLETED_AUTH);
        updateNativeAppQueryParams_LocalStorage(null, QS, LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO);
        history.push(nativeAppRoutePaths.WEB_TO_APP_REDIRECTION);
    }

    useEffect(() => {
        dispatch(FetchUserBOCIdByADB2CIdStandaloneProcess());
    }, [dispatch]);

    /**
    * Handle BOCUserInfo API success or failure
    */
    useEffect(() => {
        if(BOCUserInfosuccess){
            if(BOCUserInfoData.BOC_NO_UserID_Err){
                fetchToken();
            } else if (BOCUserInfoData?.userId && !isAuthTokenInfoExists){
                fetchToken();
            } else if (BOCUserInfoData?.userId && isAuthTokenInfoExists){
                handleAppRedirection();
            }
        }
        // eslint-disable-next-line
    }, [BOCUserInfosuccess, BOCUserInfoData]);

    /**
    * Handle fetchToken() success or failure
    */
    useEffect(() => {
        if(BOLApiToken_success){
            if(BOLApiToken_data?.is_retry){
                fetchToken();
            } else if(BOCUserInfoData?.userId && isAuthTokenInfoExists){
                handleAppRedirection();
            } else if(BOCUserInfoData?.BOC_NO_UserID_Err){
                dispatch(FetchUserBOCIdByADB2CIdStandaloneProcess());
            }
        }
        // eslint-disable-next-line
    }, [BOLApiToken_success, BOLApiToken_data])

    if(BOCUserInfoErr || BOLApiToken_error){
        return <ErrorPage errorInfo = {
                    BOCUserInfoErr 
                    || BOLApiToken_error 
                    ||  t('ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR')
                }/>
    }

    return (
        <Loader />
    );
}

export default AuthOnlyHandler;